import { MENU_KEYS, URLS } from '../../config/constants';

import { TRIGGER_TYPE } from '@mindtickle/actions-dropdown';
import { isRemoteIntialised } from '@mindtickle/ui-shell-core/DynamicRemote';
import { DYNAMIC_REMOTES } from '~/config/app.constants';
import { MIXPANEL_EVENTS } from '../../mixpanel/config';
import LearningSite from './components/MenuItem/LearningSite';
import UserProfile from '~/components/GlobalHeader/Shared/components/ProfileDetail';
import SwitchDomain from './components/MenuItem/SwitchDomain';
import { ProfileMenuArgType } from './type';
import AdvanceLink from '../AdvanceLink';
import Label from '@mindtickle/label';
import { TEXT_COLORS, TEXT_TYPES } from '@mindtickle/styles/lib/classNames';
import messages from './messages';

import SignOut from '~/components/GlobalHeader/Shared/components/SignOut';

function ensureUrlWithHttp(url: string) {
  const regex = /^(https?:\/\/)/i;
  if (regex.test(url)) {
    return url;
  } else {
    return 'https://' + url;
  }
}

export const PROFILE_MENU_OPTIONS = ({
  company,
  logout,
  user,
  track,
  navigate,
  onHideDropdownContent,
  intl,
}: ProfileMenuArgType) => ({
  [MENU_KEYS.PROFILE]: {
    key: MENU_KEYS.PROFILE,
    content: (
      <UserProfile
        user={user}
        customViewProfileNode={
          <AdvanceLink
            url={URLS.PROFILE}
            onClick={() => track(MIXPANEL_EVENTS.VIEW_PROFILE)}
            relocate
          >
            <Label
              type={TEXT_TYPES.LABEL_MEDIUM_DEFAULT}
              color={TEXT_COLORS.TERTIARY}
              message={messages.VIEW_PROFILE}
              data-testid={'view-profile-btn'}
              className="view-profile"
            />
          </AdvanceLink>
        }
      />
    ),
    triggerType: TRIGGER_TYPE.COMPONENT,
    overrideItemStyle: true,
    showBottomBorder: true,
  },

  [MENU_KEYS.GO_TO_LEARNING_SITE]: {
    key: MENU_KEYS.GO_TO_LEARNING_SITE,
    dataTestId: 'link-view-as-learner',
    content: (
      <LearningSite
        url={ensureUrlWithHttp(company.url)}
        eventName={MIXPANEL_EVENTS.GO_TO_LEARNING_SITE}
        onHideDropdownContent={onHideDropdownContent}
        track={track}
        intl={intl}
      />
    ),
    disabled: false,
    triggerType: TRIGGER_TYPE.COMPONENT,
    overrideItemStyle: true,
    showBottomBorder: false,
  },
  [MENU_KEYS.SWITCH_LEARNING_SITE]: {
    key: MENU_KEYS.SWITCH_DOMAIN,
    dataTestId: 'link-switch-learning-site',
    content: (
      <SwitchDomain
        eventName={MIXPANEL_EVENTS.SWITCH_LEARNING_SITE}
        defer={() => isRemoteIntialised(DYNAMIC_REMOTES.CHOOSE_LEARNING_SITE.remoteName)}
        onHideDropdownContent={onHideDropdownContent}
        track={track}
        domain={DYNAMIC_REMOTES.CHOOSE_LEARNING_SITE}
        menuKey={MENU_KEYS.SWITCH_LEARNING_SITE}
      />
    ),
    overrideItemStyle: false,
    disabled: false,
    showBottomBorder: false,
    triggerType: TRIGGER_TYPE.FUNCTION,
  },
  [MENU_KEYS.ANNOUNCEMENT]: {
    key: MENU_KEYS.ANNOUNCEMENT,
    dataTestId: 'link-switch-announcement',
    content: (
      <SwitchDomain
        eventName={MIXPANEL_EVENTS.ANNOUNCEMENT}
        defer={() => isRemoteIntialised(DYNAMIC_REMOTES.ANNOUNCEMENT.remoteName)}
        onHideDropdownContent={onHideDropdownContent}
        track={track}
        domain={DYNAMIC_REMOTES.ANNOUNCEMENT}
        menuKey={MENU_KEYS.ANNOUNCEMENT}
        className="styled-content"
      />
    ),
    overrideItemStyle: true,
    disabled: false,
    showBottomBorder: true,
    triggerType: TRIGGER_TYPE.FUNCTION,
  },
  [MENU_KEYS.LOGOUT]: {
    key: MENU_KEYS.LOGOUT,
    content: <SignOut logout={logout} track={track} eventName={MIXPANEL_EVENTS.LOGOUT} />,
    triggerType: TRIGGER_TYPE.COMPONENT,
  },
});
